import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "./context/AuthContext";
import { ProsProvider } from "./context/ProsContext";
import { HistoryProvider } from "./context/HistoryContext";
import { ConversationsProvider } from "./context/ConversationsContext";
import { ActivityProvider } from "./context/ActivityContext";
import { FiltersProvider } from './context/FiltersContext';

function setVh() {
  const vh = (window.visualViewport?.height || window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVh();
addEventListener('resize', setVh);

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <FiltersProvider>
      <HistoryProvider>
        <ProsProvider>
          <ActivityProvider>
            <ConversationsProvider>
                <App />
            </ConversationsProvider>
          </ActivityProvider>
        </ProsProvider>
      </HistoryProvider>
    </FiltersProvider>
  </AuthProvider>
);
